import { Injectable } from '@angular/core';
import { HttpClient } from '../../../node_modules/@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CodigoPromocionalService {

  constructor(private _http: HttpClient) { }

  listarCodigos(idCliente: number) {
    const url = environment.URL_BASE + 'promocionAuthorization/wmObtenerPromocionCliente?idCliente=' + idCliente;
    return this._http.get(url);
  }

  activarCodigo(json: any){
    const url = environment.URL_BASE + 'promocionAuthorization/wmRegistrarPromocion';
    return this._http.post(url,json);
  }
}
